// extracted by mini-css-extract-plugin
module.exports = {"Nav":"Nav_Nav__XuWZl","AuthButton":"Nav_AuthButton__py2_s"};